import React from 'react'

interface TickSuggestedBadgeProps {
	suggested?: boolean
	level?: number | null
}

// UD-784: a member at XP level 6 or more with no green tick yet. Only a hint for staff, who turn
// the green tick (Regular) on by hand with the existing control.
function TickSuggestedBadge({ suggested, level }: TickSuggestedBadgeProps) {
	if (!suggested) {
		return null
	}

	return (
		<span
			title="Level 6 or more and no green tick yet. Turn Regular on by hand if approved."
			style={{
				display: 'inline-block',
				marginTop: 2,
				padding: '1px 8px',
				borderRadius: 10,
				background: '#FFF3CD',
				color: '#7A5B00',
				border: '1px solid #F0D98A',
				fontSize: 12,
				lineHeight: '18px',
				whiteSpace: 'nowrap',
			}}
		>
			Suggested for tick{level != null ? `, level ${level}` : ''}
		</span>
	)
}

export default React.memo(TickSuggestedBadge)
